[
    "wix.com",
    "editorx.com",
    "wix-code.com",
    "wixapps.net",
    "wixprod.net"
]
